<script>
  import { onMount } from "svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import axios from "axios"
  import ApplicationState, { getupdatedAppStateValue } from "../../../../Stores/applicationStates"
  import notify from "../../../../Script/notify"
  import SinglePublish, { updateSinglePublish } from "../Stores/singlePublishStore"
  import { loadJs } from "../../../../Script/loadLibrary"
  import AuthInput from "../../../../Shared/authInput.svelte"
  import { querystring, push } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Header from "../Components/Header.svelte"
  import LoadingScreen from "../Components/loadingScreen.svelte"
  import { patchRequest, getRequest } from "../../../../Script/apiMethods"
  // import { getDocumentIdDetails } from "../script"

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {Object} - object get from window location
   */
  let query = queryStringToJSON($querystring)

  /**
   * @type {String} - massage for loading screen
   */
  let msg = "Signed PDF loading"

  /**
   * @type {Boolean} - whether to show publish otp model or not
   */
  let PublishOTPModel = false

  /**
   * @type {String} - this variable store the user entered OPT
   */
  let code = ""

  /**
   * @type {String} - this variable store the document signature for publish
   */
  let signature = ""

  /**
   * @type {Boolean} - whether to show pdf loading screen or not
   */
  let loadingPDF = true

  /**
   * @type {Object} - store the pdf details
   */
  let _PDFDOC

  /**
   * @type {Number} - PDF total page number
   */
  let totalPages

  /**
   * @type {Number} - PDF current page number
   */
  let currentpage = 1

  /**
   * @type {Number} - while changing pages number simultaneously that pages number stored as pending page number
   */
  let pageNumPending = null

  /**
   * @type {HTMLElement} - PDF showing canvas
   * */
  let canvas

  /**
   * @type {publishNotify}
   */
  let publishNotify = {
    close() {},
  }

  /**
   * here is the function for showing pdf or image
   */
  onMount(async () => {
    $SinglePublish.fileType = "pdf"
    try {
      if ($SinglePublish.docketId) {
        let fileData = await fetchFile()

        $SinglePublish.uri = URL.createObjectURL(fileData)
        await showPDF($SinglePublish.uri)
      } else {
        let blob = await getFileType()
        if (blob.headers[`content-type`].split("/")[1] == "pdf") {
          $SinglePublish.fileType = "pdf"
          await showPDF($SinglePublish.uri)
        } else $SinglePublish.fileType = "image"
      }

      loadingPDF = false
      // await getPublishSignature()
    } catch (error) {
      const info = "PAGE: Single Publish (Document details Preview before publish)\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const fetchFile = async () => {
    try {
      const FILEPATH = `/api/pdf-signing/v2/docket/${$SinglePublish.docketId}/file`
      const CONFIG = {
        headers: {
          "msign-org-token": $ApplicationState.msignToken,
        },
        responseType: "blob",
      }

      const response = await getRequest(FILEPATH, CONFIG)

      return response
    } catch (error) {
      console.error(error)
      throw error
    }
  }

  /**
   * function for find the file type
   */
  const getFileType = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const request = await axios.get(`${$SinglePublish.uri}`)
        resolve(request)
      } catch (error) {
        reject(error)
      }
    })
  }
  /**
   * @description function for fetch PDF details
   */
  const showPDF = async (url) => {
    await loadJs("pdfjsLib", "assets/lib/pdf.js")
    await loadJs("pdfjsWorker", "assets/lib/pdf.worker.js")
    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc = "assets/lib/pdf.worker.js"

    // Asynchronous download of PDF
    let loadingTask = pdfjsLib.getDocument(url)
    loadingTask = loadingTask.promise
    _PDFDOC = await loadingTask
    totalPages = _PDFDOC.numPages
    showPage(1)
  }

  /**
   * @description function for render selected PDF page number
   */
  const showPage = async (pageno) => {
    try {
      loadingPDF = true
      let page = await _PDFDOC.getPage(pageno)
      let viewport = page.getViewport({ scale: 1 })

      // Prepare canvas using PDF page dimensions
      let context = canvas.getContext("2d")
      canvas.height = viewport.height
      canvas.width = viewport.width

      // Render PDF page into canvas context
      let renderContext = {
        canvasContext: context,
        viewport: viewport,
      }
      await page.render(renderContext).promise
      loadingPDF = false
      if (pageNumPending !== null) {
        // New page rendering is pending
        showPage(pageNumPending)
        pageNumPending = null
      }
    } catch (error) {
      loadingPDF = false
      // console.error(error)
    }
  }

  /**
   * @description function for queued simultaneously changed page number
   */
  function queueRenderPage(pageno) {
    if (loadingPDF) {
      pageNumPending = pageno
    } else {
      showPage(pageno)
    }
  }

  /**
   * @description function for changed PDF page number
   */
  const changePdfPageNo = (e) => {
    if (e.target.value <= totalPages && e.target.value != 0) {
      currentpage = Number(e.target.value)
      queueRenderPage(currentpage)
    } else {
      if (e.target.value > totalPages) {
        let prevPage = currentpage

        currentpage = totalPages

        if (prevPage != currentpage) queueRenderPage(totalPages)
      } else if (e.target.value < 1) {
        currentpage = ""
        queueRenderPage(1)
      }
    }
  }

  /**
   * @description function for changed PDF page number while scroll the mouse
   */
  const changePdfPageNoWhileScroll = (e) => {
    if (e.deltaY < 0 && currentpage > 1) {
      currentpage--
      queueRenderPage(currentpage)
    } else if (e.deltaY > 0 && currentpage < totalPages) {
      currentpage++
      queueRenderPage(currentpage)
    }
  }

  /**
   * @description function for publish the document
   */
  const publish = async () => {
    msg = "Document publishing"
    apiCallBtnDisable = true
    let PublishDocIntervel
    let sampleObj = {
      documentID: $SinglePublish.documentId,
      signature: signature,
    }
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      // const { data } = await axios.post(`/api/swagger/v2/docs/publish`, sampleObj, {
      const { data } = await axios.post(`/api/swagger/v2/documents/${$SinglePublish.documentId}/publish`, sampleObj, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })
      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }
      PublishOTPModel = false
      if (data.state == "QUEUED") {
        PublishDocIntervel = setInterval(() => {
          clearInterval(PublishDocIntervel)
          publish()
        }, 5000)
        // publishNotify = notify.success("Your Document is <strong>QUEUED</strong>")
      }
      if (data.state == "PUBLISHED") {
        clearInterval(PublishDocIntervel)

        if ($SinglePublish.docketId) {
          const REQ_URL = `/api/pdf-signing/v2/docket/${$SinglePublish.docketId}`
          const CONFIG = {
            headers: {
              "msign-org-token": $ApplicationState.msignToken,
            },
          }

          await patchRequest(REQ_URL, {}, CONFIG)
        }

        apiCallBtnDisable = false
        publishNotify = notify.success("Document <strong>PUBLISHED</strong> successfully")
        $SinglePublish.proposedURL = data.url
        $SinglePublish.datePublished = new Date().toISOString()
        if ($SinglePublish.docketId) push(`/signing/single/docket?id=${$SinglePublish.docketId}`)
        else push(`/publish/single/qrcode?documentId=${$SinglePublish.documentId}`)
        updateSinglePublish($SinglePublish)
        return
      }
    } catch (error) {
      // console.error(error)
      code = ""
      const info = "PAGE: Single Publish (Document details Preview before publish)\nEVENT: During publish process"
      //throws error as danger notification
      notify.danger(error, info)
      apiCallBtnDisable = false
    }
  }

  /**
   * @description function for genarate signature for publishing
   */
  const getPublishSignature = async (e) => {
    let target = e.detail.target

    code = target[0].value + target[1].value + target[2].value + target[3].value + target[4].value + target[5].value

    let obj = {
      msg: $SinglePublish.fileHash + $SinglePublish.dataHash,
      otp: code,
    }
    // apiCallBtnDisable = true
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      const { data } = await axios.post(`/api/swagger/v2/misc/proxy-sign`, obj, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })
      if (data.error && !data.success) {
        //throw if any error occurs during api call
        throw data.errorCode
      }
      signature = data.signature
      publish()
    } catch (error) {
      // console.error(error)
      //throws error as danger notification
      const info = "PAGE: Single Publish (Document details Preview before publish)\nEVENT: During signature generation before publish"
      notify.danger(error, info)
      // apiCallBtnDisable = false
    } finally {
      code = ""
      // updateSinglePublish($SinglePublish)
    }
  }
</script>

<svelte:window
  on:visibilitychange={() => ($ApplicationState = getupdatedAppStateValue())}
  on:load={() => {
    push(`/publish/single?documentId=${query.documentId}`)
  }}
/>

<svelte:head>
  <title>Single Document Publish</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-hidden bg-[#f7f7f7] dark:bg-bodyblack">
  <Navbar />
  <div class="px-6">
    <div class="mx-auto h-auto w-full max-w-[920px] pb-40 pt-6">
      <Header bind:apiCallBtnDisable bind:msg />
      {#if PublishOTPModel}
        <div class="fixed inset-0 z-10 mt-0 flex flex-col items-center justify-center gap-3 overflow-hidden bg-[#000000cc] backdrop-blur-md">
          <div class="relative m-6 transform select-none rounded-md bg-white text-left transition-all dark:bg-bodyblack md:m-0 md:w-[700px]">
            {#if $ApplicationState.secret}
              <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
                <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Confirmation</h1>
              </div>

              <div class="px-3 py-3">
                <AuthInput bind:code on:submit={getPublishSignature} cancelBtn={true} on:click={() => (PublishOTPModel = false)} title={"Please provide a <strong>Authentication Code from the linked Authenticator App</strong> to confirm the publication of the document."} />
              </div>
            {:else}
              <div class="flex w-full items-center justify-center rounded-md bg-white p-3 pb-0 text-black dark:bg-bodyblack md:px-6 md:pt-6">
                <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Information</h1>
              </div>

              <div class="px-3 py-3">
                <h1 class="mb-6 block w-full select-none text-center text-sm font-medium text-gray-200 mobile:text-base">
                  To proceed with the publishing process, you must enable 2FA. Once enabled, you can return here by navigating to <strong>Documents > Pending Documents</strong>
                  and clicking on
                  <strong>"{$SinglePublish.options.title || "Untitled document"} for {$SinglePublish.Json.receiver.name}".</strong>
                </h1>
                <div class="flex w-full justify-center">
                  <a href="#/settings/integration/authenticator" target="_blank" class="mt-6 flex h-9 w-fit min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4">
                    <i class="fa-solid fa-diamond-turn-right" />
                    &nbsp;&nbsp;Goto 2F Authentication&nbsp;
                  </a>
                </div>
              </div>
            {/if}
          </div>
        </div>
      {/if}
      <div class="relative flex min-h-[530px] flex-col justify-between gap-6 rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12">
        <div class="flex h-full flex-col items-center justify-center gap-6 mobile:gap-3 sm:flex-row sm:items-start">
          <div class="flex w-full flex-col items-center gap-3 rounded-md mobile:w-1/2">
            <div class="rounded-md {loadingPDF ? 'animate-pulse bg-gray-100/10' : ''}">
              <!-- sm:h-[550px] -->
              {#if $SinglePublish.fileType == "pdf"}
                <canvas bind:this={canvas} on:wheel|preventDefault|stopPropagation={(e) => changePdfPageNoWhileScroll(e)} class="h-full w-full rounded-md border border-gray-800" />
              {:else}
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img src={$SinglePublish.uri} alt="publishing image" class="rounded-md border border-gray-800" />
              {/if}
            </div>
            {#if $SinglePublish.fileType == "pdf"}
              <div class="{!loadingPDF ? 'opacity-100' : ' opacity-0'} mt-3 flex w-full items-center justify-center gap-3">
                <!-- Previous Page Button -->
                <button
                  on:click={() => {
                    currentpage--
                    queueRenderPage(currentpage)
                  }}
                  type="button"
                  disabled={currentpage == 1}
                  class="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-800 text-xs text-gray-800 hover:border-black hover:text-black active:border-white active:bg-blue-500 active:text-white disabled:cursor-not-allowed dark:hover:border-white dark:hover:text-white md:h-8 md:w-8 md:text-base"
                >
                  <i class="fa-solid fa-chevron-left" />
                </button>

                <!-- Page Number Input Box -->
                <div class="flex h-8 w-auto items-center justify-between px-2">
                  <input
                    min="1"
                    max={totalPages}
                    bind:value={currentpage}
                    type="number"
                    disabled={totalPages == 1}
                    class="w-auto rounded-md border border-none bg-transparent text-left font-mono font-bold text-black focus:outline-none dark:text-white"
                    on:input|stopPropagation={(e) => changePdfPageNo(e)}
                    on:wheel|preventDefault|stopPropagation={(e) => {
                      if (e.deltaY < 0 && currentpage < totalPages) {
                        currentpage++
                        queueRenderPage(currentpage)
                      } else if (e.deltaY > 0 && currentpage > 1) {
                        currentpage--
                        queueRenderPage(currentpage)
                      }
                    }}
                    on:paste|preventDefault
                    on:blur={() => {
                      if (currentpage == "") currentpage = 1
                    }}
                  />

                  <p class="select-none text-center font-mono font-bold text-gray-800">
                    /&nbsp;{totalPages}
                  </p>
                </div>

                <!-- Next Page Button -->
                <button
                  on:click={() => {
                    currentpage++
                    queueRenderPage(currentpage)
                  }}
                  type="button"
                  disabled={currentpage == totalPages}
                  class="flex h-6 w-6 items-center justify-center rounded-full border-2 border-gray-800 text-xs text-gray-800 hover:border-black hover:text-black active:border-white active:bg-blue-500 active:text-white disabled:cursor-not-allowed dark:hover:border-white dark:hover:text-white md:h-8 md:w-8 md:text-base"
                >
                  <i class="fa-solid fa-chevron-right" />
                </button>
              </div>
            {/if}
          </div>
          <div class="h-[645px] w-full overflow-auto pr-3 sm:w-1/2">
            {#if $SinglePublish.Json}
              <h1 class="select-none pb-3 text-2xl font-bold text-black dark:text-white">Metadata</h1>
              {#each Object.keys($SinglePublish.Json) as title}
                <div class="group rounded-md p-2 pl-6 hover:bg-[#38BDF8]/20">
                  <h3 class="my-3 mb-2 select-none text-lg text-blue-500">
                    <strong class=" capitalize">{title}</strong>
                    details
                  </h3>
                  {#each Object.entries($SinglePublish.Json[title]) as [keys, values]}
                    <div class="mb-2 w-full select-none px-3">
                      <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">{keys}</p>
                      <p class="truncate font-medium capitalize text-gray-200">{values}</p>
                    </div>
                  {/each}
                </div>
              {/each}
            {/if}
            <h1 class="select-none py-3 text-2xl font-bold text-black dark:text-white">Options</h1>
            <div class="group rounded-md p-2 pl-6 pt-4 hover:bg-[#38BDF8]/20">
              {#if $SinglePublish.options}
                {#each Object.entries($SinglePublish.options) as [keys, values]}
                  <div class="mb-2 w-full select-none px-3">
                    <p class="font-semibold capitalize text-gray-800 dark:text-gray-500">{keys != "title" ? keys : "Webpage Title"}</p>
                    <p class="truncate font-medium capitalize text-gray-200">{keys == "date" || keys == "expireOn" ? new Date(values).toDateString() : values}</p>
                  </div>
                {/each}
              {/if}
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button on:click={() => (PublishOTPModel = true)} type="button" class="flex h-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500 disabled:cursor-not-allowed lg:px-4">
            <i class="fa-solid fa-upload" />
            <span class="select-none md:block">&nbsp;&nbsp;Publish to BlockChain&nbsp;</span>
          </button>
        </div>
        {#if apiCallBtnDisable}
          <LoadingScreen {msg} />
        {/if}
      </div>
    </div>
  </div>
  <Footer />
</div>
